// Shared UK city map for the CityPinTicker and Discover city-filter URL.
// Keep in sync with /app/backend/utils/uk_cities.py.

export const UK_CITIES = [
  { slug: 'london',       label: 'London' },
  { slug: 'manchester',   label: 'Manchester' },
  { slug: 'sheffield',    label: 'Sheffield' },
  { slug: 'birmingham',   label: 'Birmingham' },
  { slug: 'leeds',        label: 'Leeds' },
  { slug: 'bristol',      label: 'Bristol' },
  { slug: 'glasgow',      label: 'Glasgow' },
  { slug: 'liverpool',    label: 'Liverpool' },
  { slug: 'edinburgh',    label: 'Edinburgh' },
  { slug: 'cardiff',      label: 'Cardiff' },
  { slug: 'nottingham',   label: 'Nottingham' },
  { slug: 'newcastle',    label: 'Newcastle' },
  { slug: 'southampton',  label: 'Southampton' },
  { slug: 'brighton',     label: 'Brighton' },
  { slug: 'leicester',    label: 'Leicester' },
];

export const CITY_BY_SLUG = Object.fromEntries(UK_CITIES.map((c) => [c.slug, c]));

export const DEFAULT_CITY_RADIUS_MILES = 20;
